import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

export function createLocalStoragePersister({ cacheKey }: { cacheKey: string }) {
  return createSyncStoragePersister({
    key: cacheKey,
    storage: window.localStorage,
  });
}
